import clsx from "clsx";
import type { ReactNode } from "react";

export type BubbleTail = "bottom-right" | "bottom-left" | "none";

// The body half of the Figma's speech pattern: a wide rounded bubble in
// sidecar with a tail dropping out of one bottom corner. SpeechHeading is the
// pill that introduces it; this is what the voice actually says.
export default function SpeechBubble({
  tail = "bottom-right",
  children,
  className,
  bodyClassName,
  "data-slot": dataSlot,
}: {
  tail?: BubbleTail;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  "data-slot"?: string;
}) {
  return (
    <div data-slot={dataSlot} className={clsx("relative", className)}>
      {tail !== "none" && (
        // Same trick as SpeechHeading: a rotated square straddling the bottom
        // edge, behind the bubble, so the bubble's fill hides the seam. It has
        // to be a sibling of the bubble rather than a child - a parent's own
        // background always paints over its descendants.
        <div
          aria-hidden
          className={clsx(
            "border-bubble-ink bg-bubble-body absolute bottom-0 z-0 h-6 w-6 translate-y-1/2 rotate-45 border-r-2 border-b-2",
            tail === "bottom-right" ? "right-12" : "left-12",
          )}
        />
      )}

      <div
        className={clsx(
          "border-bubble-ink bg-bubble-body shadow-card relative z-10 h-full rounded-lg border-2 p-6 sm:p-8",
          bodyClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
